import { onFind } from '@elements/init-modules-in-scope'
import { on, findAllIn, findAll, addClass, removeClass } from '@elements/dom-utils'
import { doAsynchronously, doInstantly } from "./microinteraction-helpers";

const selectors = {
    buttonIcons: `.js-slider-animations-main-icon, .js-slider-animations-helper-icon`,
    buttonRight: '.js-slider-animations-button-right',
    buttonLeft: '.js-slider-animations-button-left',
    buttonWrapper: '.js-slider-animation-button-wrapper'
}

export function init() {
    onFind(selectors.buttonWrapper, () => {
        // set initial transition times of icons
        doAsynchronously(() => {
            findAll(selectors.buttonIcons).forEach((icon) => {
                addClass("have-transition", icon)
            })
        })

        handleButtonClick(selectors.buttonRight)
        handleButtonClick(selectors.buttonLeft)

        function handleButtonClick(selector) {
            findAll(selector).forEach((button) => {
                let buttonLocked = false // against spam

                on('click', () => {
                    if(buttonLocked) return

                    buttonLocked = true
                    findAllIn(selectors.buttonIcons, button).forEach((icon) => {
                        addClass("is-transitioning", icon)
                    })

                    setTimeout(() => {
                        buttonLocked = false
                    }, 750) // delay has to fit the transition time of slider
                }, button)

                findAllIn(selectors.buttonIcons, button).forEach((icon) => {
                    on("transitionend", () => {
                        doInstantly(icon, () => {
                            removeClass("is-transitioning", icon)
                        })
                    }, icon)
                })
            })
        }
    })
}
